import React, { FC } from "react";

interface WhiteTitleCardProps {
  cardTitle?: string;
  children: any;
}

const WhiteTitledCard: FC<WhiteTitleCardProps> = ({ cardTitle, children }) => {
  return (
    <div className="flex flex-col bg-white rounded-3xl sm:p-6 gap-6 w-full h-auto p-2">
      <h4 className="font-bold text-lg capitalize">{cardTitle}</h4>
      <div className="w-full">{children}</div>
    </div>
  );
};

export default WhiteTitledCard;
